import { SPACE_DENSITIES } from './types';
import type { SpaceDensity } from './types';

/**
 * Coerce an arbitrary backend value into a known `SpaceDensity`, or `undefined`.
 *
 * The backend stores the choice as the `HelpCenterSpaceDensity` enum
 * (`DEFAULT` / `COMFORTABLE` / `BREEZY`), which the FE `SpaceDensity` type
 * mirrors verbatim. This guard protects against a value the FE doesn't
 * recognise — a new density added server-side before this enum is updated.
 *
 * Returns the validated density, or `undefined` for `null` / `undefined` / any
 * unrecognised value. `undefined` deliberately means "not set at the BE": it
 * keeps "never chosen" distinguishable from "explicitly DEFAULT" so the publish
 * flow's dirty detection doesn't persist DEFAULT on an untouched hub. The
 * framework default (`DEFAULT_SPACE_DENSITY`) is applied at the point of
 * consumption (the config panel control).
 */
export const toSpaceDensity = (value: string | null | undefined): SpaceDensity | undefined =>
	value != null && (SPACE_DENSITIES as readonly string[]).includes(value)
		? (value as SpaceDensity)
		: undefined;
